import { ezResourceGrid } from 'ez-styles/assets/js/justified-grid';

window.ezResourceGrid = ezResourceGrid;
